import {
  SessionDocumentInfo,
  AppliedDiscountMeta,
  ModifiedDocumentMeta,
} from '@arc/unified-payments-frontend/shared-payment';
import { createAction, props } from '@ngrx/store';

export const sessionDocumentDataUpdated = createAction(
  '[POI Session - Payment Details] Session Document Data Updated',
  props<{
    selectedDocuments?: SessionDocumentInfo[];
    modifiedDocumentBurns?: ModifiedDocumentMeta[];
    appliedDiscountMetadata?: AppliedDiscountMeta[];
  }>(),
);

export const selectedDocumentsUpdated = createAction(
  '[POI Session - Payment Details] Selected Documents Updated',
  props<{
    updatedSelectedDocuments?: SessionDocumentInfo[];
  }>(),
);

export const updateModifiedDocumentsUrnListAction = createAction(
  '[POI Session - Payment Details] Update Modified Documents Urn List',
  props<{
    updatedModifiedDocumentsUrnList?: ModifiedDocumentMeta[];
  }>(),
);
